import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from '@/seo/data';
import { applyHeadSeo, resetHeadSeo } from '@/seo/head';
import { setWebsiteJsonLd, setArticleJsonLd, clearJsonLd } from '@/seo/schema';
import { absoluteUrl } from '@/seo/site';

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveSeo(pathname);

    if (!seo) {
      resetHeadSeo();
      clearJsonLd();
      return;
    }

    applyHeadSeo({
      title: seo.title,
      description: seo.description,
      keywords: seo.keywords,
      canonical: absoluteUrl(seo.canonicalPath),
      image: seo.image,
      type: seo.type,
    });

    if (seo.jsonLd === 'website') {
      setWebsiteJsonLd(seo.description);
    } else if (seo.jsonLd === 'article' && seo.image) {
      setArticleJsonLd({
        title: seo.title,
        description: seo.description,
        image: seo.image,
        url: absoluteUrl(seo.canonicalPath),
      });
    } else {
      clearJsonLd();
    }
  }, [pathname]);

  return null;
}